import { reportConversion } from '../utils/gtag';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
  <footer className="bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950 text-gray-200 pt-14 pb-8" id="contact">
      <div className="max-w-7xl mx-auto px-4 grid gap-12 md:grid-cols-4">
        {/* Brand */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4 tracking-wide">{t('footer.about.title')}</h3>
          <p className="text-sm leading-relaxed text-gray-400 max-w-xs">{t('footer.about.desc')}</p>
          <div className="mt-6">
            <p className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-3">Follow Us</p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/vigor_auto_repair_garage_dubai/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="group relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 via-rose-500 to-orange-400 text-white shadow-md shadow-pink-600/30 hover:shadow-lg hover:scale-[1.05] active:scale-[0.97] transition"
              >
                <InstagramIcon className="w-5 h-5" />
                <span className="pointer-events-none absolute inset-0 rounded-full ring-0 group-hover:ring-2 ring-white/30 transition"></span>
              </a>
              <a
                href="https://www.facebook.com/people/Vigor-Auto-Repair-Garage/61578113691650/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="group relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-md shadow-blue-700/30 hover:shadow-lg hover:scale-[1.05] active:scale-[0.97] transition"
              >
                <FacebookIcon className="w-5 h-5" />
                <span className="pointer-events-none absolute inset-0 rounded-full ring-0 group-hover:ring-2 ring-white/30 transition"></span>
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-semibold mb-4 tracking-wide">{t('nav.home')}</h4>
          <ul className="space-y-2 text-sm">
            <li><a className="hover:text-white transition-colors" href="/">{t('nav.home')}</a></li>
            <li><a className="hover:text-white transition-colors" href="/about">{t('nav.about')}</a></li>
            <li><a className="hover:text-white transition-colors" href="/services">{t('nav.services')}</a></li>
            <li><a className="hover:text-white transition-colors" href="/offers">{t('nav.offers')}</a></li>
            <li><a className="hover:text-white transition-colors" href="/testimonials">{t('nav.testimonials')}</a></li>
            <li><a className="hover:text-white transition-colors" href="/contact">{t('nav.contact')}</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold mb-4 tracking-wide">{t('footer.contact.title')}</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <span className="block text-gray-500 text-[11px] uppercase tracking-wide">{t('contact.location.title')}</span>
              <a href="https://maps.app.goo.gl/TUp25rLZUxxKZjAn8" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">{t('footer.location')}</a>
            </li>
            <li>
              <span className="block text-gray-500 text-[11px] uppercase tracking-wide">Phone</span>
              <div className="flex flex-col">
                <a dir="ltr" href="tel:+971568699800" onClick={() => reportConversion('tel:+971568699800')} className="hover:text-white transition-colors">+971 56 8699 800</a>
                <a dir="ltr" href="tel:+971524333690" onClick={() => reportConversion('tel:+971524333690')} className="hover:text-white transition-colors">+971 52 433 3690</a>
              </div>
            </li>
            <li>
              <span className="block text-gray-500 text-[11px] uppercase tracking-wide">WhatsApp</span>
              <div className="flex flex-col">
                <a href="https://wa.me/971568699800" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Chat Now</a>
                <a href="https://wa.me/971524333690" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Chat Now</a>
              </div>
            </li>
            <li>
              <span className="block text-gray-500 text-[11px] uppercase tracking-wide">Email</span>
              <a href="mailto:info@vigorautorepair.com" className="hover:text-white transition-colors">info@vigorautorepair.com</a>
            </li>
            <li>
              <span className="block text-gray-500 text-[11px] uppercase tracking-wide">{t('contact.hours.title')}</span>
              <span className="text-gray-400">{t('contact.hours.value')}</span>
            </li>
          </ul>
        </div>

        {/* Service Focus */}
        <div>
          <h4 className="text-white font-semibold mb-4 tracking-wide">{t('footer.services.title')}</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>{t('footer.services.diagnostics')}</li>
            <li>{t('footer.services.performance')}</li>
            <li>{t('footer.services.detailing')}</li>
            <li>{t('footer.services.maintenance')}</li>
            <li>{t('footer.services.suspension')}</li>
          </ul>
        </div>
      </div>
  <div className="mt-10 pt-6 border-t border-blue-900/60 text-center text-[11px] text-gray-400">
        {t('footer.copyright')}
      </div>
    </footer>
  );
}

function InstagramIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function FacebookIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M13.5 22v-8.5H16l.5-3h-3V8.75c0-.87.28-1.5 1.7-1.5H17V4.14c-.3-.04-1.35-.14-2.57-.14-2.54 0-4.28 1.54-4.28 4.37V10.5H8v3h2.15V22h3.35Z" />
    </svg>
  );
}
